import { useId } from 'react';

const OUTLINE_COLOR = '#333333';
const FLASK_LIQUID_COLOR = '#91c0ff';
const TUBE_LIQUID_COLOR = '#fe9a8c';

// The test tube is drawn standing up with its mouth at (0, 0), then turned so its mouth
// tips towards the flask. The liquid is clipped to the tube's inside so its surface stays level.
const TUBE_TRANSFORM = 'translate(48 12) rotate(-50)';
const TUBE_LIQUID_LEVEL = 31;

/**
 * The ChemistFella logo: a test tube dripping into a round-bottom flask.
 * Used in the site header and drawn into the favicon by scripts/generate-icons.mjs.
 */
export default function LabLogo({ size = 40, className, title }) {
  const clipId = `lab-logo-tube-${useId().replace(/:/g, '')}`;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : 'true'}
    >
      <defs>
        <clipPath id={clipId}>
          <path transform={TUBE_TRANSFORM} d="M-4 0 V38 A4 4 0 0 0 4 38 V0 Z" />
        </clipPath>
      </defs>

      <path d="M18.23 70 A17.5 17.5 0 1 0 51.77 70 Z" fill={FLASK_LIQUID_COLOR} />
      <rect
        x="30"
        y={TUBE_LIQUID_LEVEL}
        width="70"
        height={60 - TUBE_LIQUID_LEVEL}
        fill={TUBE_LIQUID_COLOR}
        clipPath={`url(#${clipId})`}
      />
      <path d="M35 20 C35 20 31 25.5 31 27.5 A4 4 0 0 0 39 27.5 C39 25.5 35 20 35 20 Z" fill={TUBE_LIQUID_COLOR} />

      <g fill="none" stroke={OUTLINE_COLOR} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M30 37 V55.6 A20 20 0 1 0 40 55.6 V37" />
        <path d="M26 37 H44" />
        <g transform={TUBE_TRANSFORM}>
          <path d="M-6 0 V38 A6 6 0 0 0 6 38 V0" />
          <path d="M-9 0 H9" />
        </g>
      </g>
    </svg>
  );
}
